<template>
    <div
        class="cart-item-adjustments-details"
    >
        <template
            v-if="adjustments?.length"
        >
            <span
                class="font-weight-medium"
            >
                {{ title }}
            </span>
            <ul
                class="pa-0 ma-0 font-size-7 list-inside"
            >
                <li
                    v-for="(adj, index) in adjustments"
                    :key="index"
                >
                    {{ adj.description }} /
                    {{ formatCurrency(adj.amount) }}
                </li>
            </ul>
        </template>
    </div>
</template>

<script lang="ts" setup>
    import type { CartLineDiscount, CartLineFee } from '~/types';
    import { formatCurrency } from 'x1-base/utils';

    defineProps<{
        adjustments?: Nilish<CartLineDiscount[] |  CartLineFee[]>;
        title: Nilish<string>;
    }>();
</script>

<style lang="scss"></style>
